/**
 * Gets the current culture code from the Dayforce global object.
 * Falls back to 'en-US' if not found.
 * 
 * @returns The culture code string.
 * @example
 * 
 * CultureCodeUtil.getCultureCode();
 * // => 'en-US' or 'fr-CA', etc.
 */
function getCultureCode(): string {
    const labelCulture = window['Dayforce']?.LabelData?.culture;
    const clientCulture = window['Dayforce']?.ClientSessionData?.cultureCode;

    // Prioritize LabelData culture over ClientSessionData cultureCode
    if (labelCulture) {
        return labelCulture;
    }

    // Check ClientSessionData cultureCode next
    if (clientCulture) {
        return clientCulture;
    }

    // Fallback to browser's culture code
    if (navigator.language) {
        return navigator.language;
    }

    return 'en-US';
}

export const CultureCodeUtil = {
    getCultureCode
};

export default CultureCodeUtil;
